import './src/styles/global.css'
import "@fontsource/montserrat/800.css"
import "@fontsource/montserrat"
import "typeface-nunito-sans";

// Disable browser translation by adding classes and attributes
export const onClientEntry = () => {
  if (typeof document !== 'undefined') {
    // Add notranslate class to html and body
    document.documentElement.classList.add('notranslate');
    document.body.classList.add('notranslate');
    
    // Add translate="no" attribute
    document.documentElement.setAttribute('translate', 'no');
    document.body.setAttribute('translate', 'no');
    
    // Add lang attribute to help browsers detect the language
    document.documentElement.setAttribute('lang', 'en');
  }
}
